// extracted by mini-css-extract-plugin
module.exports = {"badges":"Badges_badges__NaPMy","badges-class":"Badges_badges-class__JJwPH","badges__youtube":"Badges_badges__youtube__vGDf6"};